import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE || "https://mystockpicks.onrender.com", // same host you already use
    timeout: 25000,
});

// Attach token automatically
api.interceptors.request.use((config) => {
    const t = localStorage.getItem("authToken");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export default api;
